<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><router-link to="/MemberCenter">首页</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>{{ contract.ContractTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">基本信息</div>
      <div>
        <el-form :inline="true" :model="contract" class="form_table" :inline-message="true">
          <el-form-item label="合同编号">
            <span>{{ contract.ContractNumber }}</span>
          </el-form-item>
          <el-form-item label="合同名称">
            <span>{{ contract.ContractTitle }}</span>
          </el-form-item>

          <el-form-item label="合同类型">
            <span v-if="contract.ContractType == 1">单次采购合同</span>
            <span v-if="contract.ContractType == 2">框架采购合同</span>
          </el-form-item>
          <el-form-item label="合同总价">
            <span>{{ contract.ContractFee }}</span>
          </el-form-item>

          <el-form-item label="甲方名称">
            <span>{{ contract.CompanyName }}</span>
          </el-form-item>
          <el-form-item label="乙方名称">
            <span>{{ contract.SupplierName }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="title">设备概况</div>
      <el-form class="rule-form" style="overflow: auto; width: 100%; margin: 0" :inline="true" :inline-message="true">
        <table class="statistics_table">
          <tbody>
            <tr>
              <th style="width: 5rem">序号</th>
              <th style="width: 8rem">货物名称</th>
              <th style="width: 8rem">规格型号</th>
              <th style="width: 8rem">品牌</th>
              <th style="width: 18.75rem">数量</th>
              <th style="width: 8rem">总价</th>
            </tr>
            <template v-for="(data, index) in instrumentList">
              <tr :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ data.SupplierInstrumentName }}</td>
                <td>{{ data.SupplierSpecification }}</td>
                <td>{{ data.Trademark }}</td>
                <td>{{ data.Count }}</td>
                <td>{{ data.Total }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </el-form>
      <div class="title">合同盖章附件</div>
      <el-form class="form_table" :model="contract" :rules="rules" :inline="true" ref="form" :inline-message="true">
        <el-form-item label="合同盖章附件" prop="ContractFile" class="all_line">
          <div class="file_wrap">
            <el-upload
              :action="uploadUrl"
              :limit="1"
              :before-remove="removeConfirm"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-change="fileChange"
              :on-exceed="exceedFile"
              :on-success="handleSuccess"
              :on-error="handleError"
              :auto-upload="true"
              :file-list="fileList"
              :data="{}"
              :http-request="uploadTechnicalFile"
              accept=".pdf"
              ref="uploader"
            >
              <el-button size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn_wrap changeInform_btn_wrap">
      <span class="btn_1" @click="fnGoBack()">返回</span>
      <span class="btn_1" @click="fnSave()">提交</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validateContractFile = (rule, value, callback) => {
      if (this.fileList.length == 0) {
        callback(new Error('请上传合同盖章附件'))
      } else {
        callback()
      }
    }
    return {
      uploadUrl: '',
      contractId: this.$route.query.contractId,
      contract: {},
      instrumentList: [],
      fileList: [],
      height: '0px',
      rules: {
        ContractFile: [{ required: true, validator: validateContractFile, trigger: 'blur' }]
      }
    }
  },
  mounted() {
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          contractId: this.contractId
        }
      }
      this.getRequest('/Contract/ContractDetail', config).then((res) => {
        if (res.data.errcode == 0) {
          this.contract = res.data.contract
          this.instrumentList = res.data.instrumentList
          // this.fileList = res.data.contractFiles;
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnGoBack() {
      window.close()
    },
    uploadTechnicalFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName,
            status: 'success'
          }
          this.fileList.push(obj)
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传1个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.fileList = this.fileList.filter((item) => {
              return item.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileList = fileList
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleUpload(raw) {},
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf' || testmsg === 'PDF'
      if (!extension) {
        this.$message({
          message: '上传文件只能是pdf格式!',
          type: 'warning'
        })
      }
      return extension
    },
    fnSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.postRequest('/Contract/SaveContractFile', {
            contractId: this.contractId,
            fileId: this.fileList[0].fileId
          }).then((res) => {
            if (res.data.errcode == 0) {
              this.$message.success('保存成功')
              localStorage.setItem('contractList', Math.random())
              window.close()
            } else {
              this.$message.error(res.data.errmsg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;
  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}
.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;
    .el-input {
      width: 200px;
    }
  }
  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }
  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .el-input {
    width: 300px;
    margin-right: 8px;
  }
  .businessTermEndDate {
    margin-bottom: 0 !important;
    .el-input {
      width: 100% !important;
    }
    .el-form-item__label:before {
      display: none;
    }
    .el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}
.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;
  .product_form {
    margin-bottom: 0;
  }
}
.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}
.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;
    .el-range-input {
      font-size: 14px;
    }
  }
}
.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;
    .el-tree-node {
      display: inline-block;
    }
  }
}
.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}
.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 98.5%;
  table-layout: fixed;
  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }
  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }
  tr {
    border-bottom: 1px solid #95c7f0;
  }
}
.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
